<div class="ts-public-home">
  <section class="ts-public-hero">
    <div class="ts-public-hero__inner">
      <div class="ts-public-hero__brand">
        <img
          class="ts-public-hero__logo"
          src="assets/public/images/mainlogo_lg.png"
          alt="TruthShorts"
        />
        <h1 class="ts-public-hero__title">
          Truth <span class="ts-public-hero__accent">For Freedom</span>
        </h1>
        <p class="ts-public-hero__tagline">Real voices. Real truth. No noise.</p>
      </div>

      <div class="ts-public-hero__panel">
        <div *ngIf="environment.googleSignInEnabled && environment.googleClientId" class="ts-google-wrap mb-3">
          <div id="googleSignInButton" class="d-flex justify-content-center"></div>
          <p *ngIf="!googleReady" class="small text-muted text-center mt-2 mb-0">
            Loading Google sign-in…
          </p>
        </div>

        <div *ngIf="environment.googleSignInEnabled && environment.googleClientId" class="ts-public-divider">
          <span>or continue with email</span>
        </div>

        <div class="mb-3">
          <input
            type="email"
            class="form-control"
            placeholder="Email or username"
            [(ngModel)]="email"
            autocomplete="username"
          />
        </div>
        <div class="mb-3">
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            [(ngModel)]="password"
            autocomplete="current-password"
          />
        </div>
        <div *ngIf="errorMessage" class="alert alert-danger py-2 small mb-2">
          {{ errorMessage }}
        </div>
        <button type="button" class="btn btn-primary w-100 mb-2" (click)="login()">
          Log In
        </button>
        <div class="text-center mb-2">
          <a routerLink="/sign_in" class="small text-muted">Classic sign-in page</a>
        </div>
        <div class="text-center mb-3">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openCreateAccount()">
            Create Account
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="ts-trending-section">
    <div class="ts-trending-section__inner">
      <h2 class="ts-trending-section__heading">Trending on TruthShorts</h2>
      <p *ngIf="trendingLoadError" class="text-danger small">{{ trendingLoadError }}</p>
      <div class="ts-trending-grid" *ngIf="trendingCards.length">
        <app-trending-post-card
          *ngFor="let c of trendingCards"
          [displayName]="c.displayName"
          [handle]="c.handle"
          [avatarUrl]="c.avatarUrl"
          [content]="c.content"
          [likes]="c.likes"
          [reposts]="c.reposts"
          [comments]="c.comments"
          [tag]="c.tag"
          [delayMs]="c.delayMs"
        />
      </div>
      <p *ngIf="!trendingCards.length && !trendingLoadError" class="text-muted small">
        No trending posts yet — check back soon.
      </p>
    </div>
  </section>

  <footer class="ts-public-footer">
    <ul class="ts-public-footer__links">
      <li><a routerLink="/privacy">Privacy Policy</a></li>
      <li><a routerLink="/tos">Terms of Service</a></li>
    </ul>
  </footer>
</div>
